// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__OgGdk","text":"style_text__3WdRo","hidden":"style_hidden__1sdVT","textColor":"style_textColor__1c3j5"};